import Card from '../elements/ReactBootstrap/Card';
import {Col, Row} from 'react-bootstrap';
import React from 'react';
import {useCreateClientMutation, useLazyListClientsQuery} from '../../features/apiSlice';
import {useNavigate} from 'react-router-dom';
import ErrorWidget from '../widgets/ErrorWidget';
import Content from '../partials/Content.jsx';
import SmallSpinner from '../elements/Spinner/SmallSpinner.jsx';
import ClientSearchWidget from "../widgets/Client/ClientSearchWidget.jsx";

const CreateClient = () => {
    const navigate = useNavigate();

    const [list, {
        data: listResult,
        error: listError,
        isLoading: listLoadingOriginal,
        isFetching: listFetchingOriginal,
        isSuccess: listSuccessOriginal,
        isError: listIsError,
    }] = useLazyListClientsQuery();

    const listLoading = listLoadingOriginal || listFetchingOriginal;
    const listSuccess = listSuccessOriginal && !listLoading;

    const [create, {
        reset: createReset,
        error: createError,
        isError: createIsError,
        isLoading: createLoading,
    }] = useCreateClientMutation();

    return (<Content title="Въвеждане на клиент">
        <Row className="row-cols row-cols-1 row-cols-xl-2">
            <Col>
                <Card outline>
                    <ClientSearchWidget formName="clientCreate" findButtonIcon="fas fa-plus" findButtonLabel="Въвеждане"
                        onSubmit={async values => {
                            createReset();

                            const result = await list({
                                query: values.pin,
                            }).unwrap();

                            if (result[0]) {
                                navigate('/client/' + result[0].id);
                                return;
                            }

                            const createdClient = await create({
                                pin: values.pin,
                            }).unwrap();
                            navigate('/client/' + createdClient.id);
                        }} >
                    </ClientSearchWidget>
                </Card>
                {listLoading && <Card>Търсене на клиент... <SmallSpinner /></Card>}
                {listIsError && <ErrorWidget error={listError} />}
                {createLoading && <Card>Въвеждане на клиент... <SmallSpinner /></Card>}
                {createIsError && <ErrorWidget error={createError} />}
                {listSuccess && listResult.length > 1 && 'списък с клиенти с един и същи идентификатор'}
            </Col>
        </Row>
    </Content>);
};

export default CreateClient;
